import { useQuery } from '@tanstack/react-query';
import { plantAssetApi } from '../api';
import { queryKeys } from '../queries/keys';

/**
 * The documents linked to the register asset that carries `tag` in the plant.
 *
 * Two reads in sequence: the register list resolves the tag to an asset, and the
 * asset's documents route lists them. The second read runs only when the tag names
 * exactly one asset.
 *
 * An SME links documents in copilot, outside this app, so both reads refetch when the
 * window regains focus and their data is stale.
 */
export function useAssetDocuments(domainId: string, tag: string) {
  const assetMatchQuery = useQuery({
    queryKey: queryKeys.plantAssetMatch(domainId, tag),
    queryFn: () => plantAssetApi.findPlantAsset(domainId, tag),
    refetchOnWindowFocus: true,
  });
  const matchedAssetId =
    assetMatchQuery.data?.match === 'one' ? assetMatchQuery.data.asset.id : '';
  const documentsQuery = useQuery({
    queryKey: queryKeys.assetDocuments(matchedAssetId),
    queryFn: () => plantAssetApi.fetchAssetDocuments(matchedAssetId),
    enabled: Boolean(matchedAssetId),
    refetchOnWindowFocus: true,
  });
  return { assetMatchQuery, documentsQuery };
}
